





















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, InjectReactive, Watch } from 'vue-property-decorator';

// Store types
import { ToolAccessory, ToolSystem } from '@/store/store.types';

// Used to render the image(s) of the accessory
import SystemImages, { SystemImage } from '../SystemImages.vue';

/**
 *  Component that renders a system's accessory, including the
 *  image(s), title, description, price and action to toggle.
 */
@Component({
    components: {
        SystemImages,
    },
})
export default class SystemAccessory extends Vue {

    @InjectReactive('toolSystem')
    private toolSystem!: ToolSystem;

    @Prop({ type: Object, required: true })
    private toolAccessory!: ToolAccessory;

    /**
     *
     *  Used to get the (system) images of the accessory.
     *
     *  (i) It currently always contains a single image
     *
     */
    private get image(): Array<SystemImage> | null {

        if (!this.toolAccessory.data.image || typeof this.toolAccessory.data.image === 'string') {

            return null;

        }

        return [
            {
                title: this.toolAccessory.data.image.name,
                src: this.toolAccessory.data.image.file,
            },
        ];

    }

    /**
     *  Used to get the description of the accessory.
     */
    private get description(): string {

        return this.toolAccessory.data.description ?? 'Er is helaas geen omschrijving beschikbaar voor deze accessoire.';

    }

    /**
     *  Used to get the title for the button to add or remove
     *  this accessory, interpolated with the name of the accessory.
     */
    private get selectTitle(): string {

        return `De accessoire "${ this.toolAccessory.data.name }" ${ this.toolAccessory.selected ? 'verwijderen' : 'selecteren' }`;

    }

    /**
     *  Watch the selected state of the system and
     *  emit an event to reset the selected state of
     *  the accessory if it got deselected.
     */
    @Watch('toolSystem.selected')
    private _systemSelectedUpdate(selected: boolean): void {

        if (selected) {

            return;

        }

        this.$emit('reset');

    }

}
